// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAMwnFce5H8SxTim5shGsR-Ej4B6ILODzU",
  authDomain: "react-contact-457e9.firebaseapp.com",
  projectId: "react-contact-457e9",
  storageBucket: "react-contact-457e9.appspot.com",
  messagingSenderId: "424342685444",
  appId: "1:424342685444:web:d879ded215eed3b91e3251"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);